import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../store";
import {ImpressionsFilters} from "../types";

export interface ImpressionsInitialState {
    filters: ImpressionsFilters;
}

export const initialImpressionsState: ImpressionsInitialState = {
    filters: {
        nameCont: '',
        fromDate: '',
        toDate: '',
        tagsNameIn: [],
        adTagsIdIn: [],
        draftMediaFormatIn: [],
        creationIds: [],
        mediumIds: [],
        media: [],
        draftId: null,
        granularity: '',
        s: '',
        format: undefined
    },
}

export const impressionsSlice = createSlice({
    name: "impressions",
    initialState: initialImpressionsState,
    reducers: {
        setFilters: (state, action: PayloadAction<ImpressionsFilters>) => {
            state.filters = action.payload
        },
    }
})

export const {setFilters} = impressionsSlice.actions;

export const selectCurrentImpressionsFiltersState = (state: RootState) => state.impressions.filters;

